
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/segment',['Vue'],function(Vue){
        return {
            name:'segment',
            template:template
        }
    })
})('<div class="segment"> <div class="segmentHeader"><slot name="header" ></slot></div> <div class="segmentBody"><slot name="body" ></slot></div> </div>');
